import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { CloudStorageService } from '../../cloud-storage.service';
import { slide } from '../../animations';

@Component({
  selector: 'provider-list',
  templateUrl: './provider-list.component.html',
  styleUrls: ['./provider-list.component.scss'],
  animations: [slide]
})
export class ProviderListComponent implements OnInit {
  providers:  FirebaseListObservable<any[]>;

  selectedProvider: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private dbService: DBService,
    private csService: CloudStorageService
  ) {
    this.providers = this.dbService.getProviders();
  }

  ngOnInit() {
  }

  showProvider(key: string) {
    this.router.navigate([`/providers/${key}`]);
  }

  providerLogo(key) {
    if (key) {
      this.csService.getProviderLogoUrl(key);
    } else {
      return "";
    }
  }

  onAddClicked() {
    this.selectedProvider = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onEditClicked(provider, event) {
    event.stopPropagation();
    this.selectedProvider = provider;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked(provider, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedProvider = provider;
  }

  onConfirmDelete() {
    this.onHideDeleteModal();
    this.dbService.deleteProvider(this.selectedProvider.$key);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/providers/provider-list/provider-list.component.ts